// 园区概况
import { getYQGKDetail } from '@/api'

const state = {
	detail: {
		parktype: '',
		content: '',
	},
}
const mutations = {
	SET_DETAIL(state, payload) {
		state.detail = payload
	},
}
const actions = {
	fetchDetailByType({ commit }, type = '') {
		getYQGKDetail(type).then((detail = {}) => {
			commit('SET_DETAIL', detail)
		})
	},
}
export default {
	namespaced: true,
	state,
	mutations,
	actions,
}
